module.exports = __webpack_public_path__ + "img/topic_appreciation.f66bb751.svg";